import { useQuery } from '@tanstack/react-query';
import { ping, getHealth, getReadiness } from '@/api/system.api';
import { qk } from '@/api/queryKeys';
import { HEALTH_POLL_INTERVAL_MS } from '@/constants';

/** Connectivity check — resolves to { message: 'pong' }. */
export function usePing(options = {}) {
  return useQuery({
    queryKey: qk.system.ping,
    queryFn: ping,
    refetchInterval: HEALTH_POLL_INTERVAL_MS,
    retry: 1,
    ...options,
  });
}

/** Liveness — { status, uptime, version }. */
export function useHealth(options = {}) {
  return useQuery({
    queryKey: qk.system.healthz,
    queryFn: getHealth,
    refetchInterval: HEALTH_POLL_INTERVAL_MS,
    retry: 1,
    ...options,
  });
}

/** Readiness — { status, checks }. A 503 body is surfaced as data (not an error). */
export function useReadiness(options = {}) {
  return useQuery({
    queryKey: qk.system.readyz,
    queryFn: getReadiness,
    refetchInterval: HEALTH_POLL_INTERVAL_MS,
    retry: 1,
    ...options,
  });
}
